import AssetsCoin from '@/assets/image/useCases/digitalAssets/AssetsCoin.png'
import '@/assets/scss/global.scss';
import './index.scss'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const Card3 = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
   return (
     <div className='digital-assets-foot'>
       {
         isDesktop?(
           <>
             <div
               className={`w-1340 pt-[180px] pb-[30px] digital-assets-foot-item pl-[192px] pr-[192px] text-[#fff] text-left flex items-end justify-center`}>
               <div>
                 <div className={`digital-assets-foot-title text-[64px]`}>
                   $10,000,000,000+
                 </div>
                 <div className={`digital-assets-foot-desc text-[18px]`}>
                   in committed multi-assets capacity for yield products.
                 </div>
               </div>
               <div className={`flex items-center ml-[24px]`}>
                 <img src={AssetsCoin} className={`h-[150px]`} />
               </div>
             </div>
             <div className={`w-1340 digital-assets-foot-item pl-[192px] pb-[120px]`}>
               <div className={`get-touch-btn`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
           </>
         ) : (
           <>
             <div
               className={`w-1340 pt-[80px] digital-assets-foot-item text-[#fff] text-center`}>
               <div className={`flex items-center justify-center mb-[40px]`}>
                 <img src={AssetsCoin} className={`h-[150px]`} />
               </div>
               <div>
                 <div className={`digital-assets-foot-title text-[24px] mb-[20px]`}>
                   $10,000,000,000+
                 </div>
                 <div className={`digital-assets-foot-desc text-[14px] mb-[20px]`}>
                   in committed multi-assets capacity for yield products.
                 </div>
               </div>
             </div>
             <div className={`w-1340 digital-assets-foot-item pb-[80px]`}>
               <div className={`get-touch-btn`} style={{ margin: '0 auto' }}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
           </>
         )
       }

     </div>

   )
}

export default Card3